import type { ReactNode } from 'react';
import clsx from 'clsx';

interface TenantBannerProps {
  application: string;
  tenantName?: string;
  actions?: ReactNode;
}

export const TenantBanner = ({ application, tenantName = 'Unknown tenant', actions }: TenantBannerProps) => {
  return (
    <header
      className={clsx(
        'tenant-banner',
        'flex items-center justify-between gap-4 border-b border-slate-200 bg-slate-50 px-6 py-4',
      )}
    >
      <div>
        <p className="text-xs uppercase tracking-wide text-slate-500">{application}</p>
        <h2 className="text-lg font-semibold text-slate-900">{tenantName}</h2>
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </header>
  );
};
